import URL from '@/tools/url';
import jquery from 'jquery';
import _toFinite from 'lodash/toFinite';

/**
 * @memberof module:ajaxAPI/cart
 * @alias remove
 *
 * @description Удаление товара из корзины.
 *
 * @param {Number} variant_id - id модификации
 *
 * @return {$.ajax}
 *
 * @example
 * ajaxAPI.cart.remove(123123)
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */

export default function(variant_id) {
  var path = '/cart_items/' + _toFinite(variant_id) + '.json';
  var _lang = URL.getKeyValue('lang') || '';
  var fields = {
    lang: _lang,
    _method: 'delete'
  };

  return jquery.post(path, fields);
};
